/* eslint-disable */
import React from 'react';
import { AddToCalendarPlacement } from 'enums';

class AddToCalendar extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        event.preventDefault();
        event.stopPropagation();
    }

    render() {
        const { placement } = this.props;
        switch (placement) {
            case AddToCalendarPlacement.ALERT:
                return (
                    <button className="button-alt med" onClick={this.handleClick}>
                        Remind Me
                    </button>
                );
            case AddToCalendarPlacement.EVENT_CARD:
                return (
                    <a
                        className="add-to-calendar icon-font-before icon-add-to-calendar-solid-before"
                        data-route="false"
                        onClick={this.handleClick}
                    />
                );
            default:
                return null;
        }
    }
}

AddToCalendar.propTypes = {
    content: React.PropTypes.object,
    placement: React.PropTypes.string
};

export default AddToCalendar;



// WEBPACK FOOTER //
// ./app/common/AddToCalendar.js